var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImmigration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.325 3.77a2 2 0 012-2h12a2 2 0 012 2v16.862a2 2 0 01-2 2h-12a2 2 0 01-2-2V3.77z",
    fill: "#3767D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.27a.5.5 0 01.5-.5h13.256a2 2 0 012 2v16.862a2 2 0 01-2 2H4.5a.5.5 0 01-.5-.5V2.27z",
    fill: "#0034A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.413,
    cy: 9.683,
    r: 4.5,
    fill: "#325AFF",
    stroke: "#C9DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.413 9.683h2.5m5.5 0h-5.5m0 0c0-1.765.541-2.917 1.026-3.535a.59.59 0 01.948 0c.485.618 1.026 1.77 1.026 3.535 0 1.765-.54 2.918-1.026 3.536a.59.59 0 01-.948 0c-.485-.618-1.026-1.77-1.026-3.536zM8.413 16.565h8M9.465 18.605h5.896",
    stroke: "#C9DAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.265a.5.5 0 01.5-.5h1.143v20.867H4.5a.5.5 0 01-.5-.5V2.265z",
    fill: "#002677"
  })));
}
export default SvgImmigration;